export default [
  {
    name: "walls",
    type: "gltfModel",
    path: "models/walls.gltf",
  },
  {
    name: "model",
    type: "gltfModel",
    path: "models/model.glb",
  },
  {
    name: "emissive",
    type: "gltfModel",
    path: "models/emissive.gltf",
  },
  {
    name: "transparent",
    type: "gltfModel",
    path: "models/transparent.glb",
  },

  {
    name: "screenStudies",
    type: "gltfModel",
    path: "models/screenStudies.glb",
  },
  {
    name: "screenCodingHor",
    type: "gltfModel",
    path: "models/screenCodingHor.glb",
  },
  {
    name: "screenCodingVert",
    type: "gltfModel",
    path: "models/screenCodingVert.glb",
  },
  {
    name: "raycasterModel",
    type: "gltfModel",
    path: "models/raycaster.gltf",
  },
];
